export const SET_ACCOUNT_DATA = "SET_ACCOUNT_DATA";
export const SET_SUCCESS = 'SET_SUCCESS'
export const SET_ERR = 'SET_ERR'
export const SET_FORMDATA = 'SET_FORMDATA'